import type { PropsWithChildren } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { Icon } from "@circle-react-shared/Icon";
import { TippyV2 } from "@circle-react-shared/TippyV2";
import { Typography } from "@circle-react-uikit/Typography";

interface ChartContainerProps {
  children: React.ReactNode;
  className?: string;
  title: string;
  tooltip?: string;
}

export const ChartContainer = ({
  title,
  tooltip,
  children,
  className,
}: PropsWithChildren<ChartContainerProps>) => (
  <div
    className={classNames(
      "border-primary flex w-full flex-col gap-2 rounded-xl border p-4",
      className,
    )}
  >
    <div className="flex items-center justify-between gap-1">
      <Typography.LabelLg
        color="text-primary dark:text-white"
        weight="semibold"
      >
        {title}
      </Typography.LabelLg>
      {tooltip && (
        <TippyV2
          content={tooltip}
          className="inline-flex cursor-pointer dark:text-white"
        >
          <Icon type="16-info" size={16} useWithStrokeCurrentColor />
        </TippyV2>
      )}
    </div>
    {children}
  </div>
);
